import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ENUM_TIPO_LAYOUT_RELATORIO_DOWNLOAD } from 'utils/consts';
import { detalharRequerimentoContribuinte } from 'routes/paths';
import { downloadFileHtmlToPdf } from 'utils/arquivo';
import { createHtmlComprovante } from './comprovante';

export default function PageComprovanteRequerimento() {
  const history = useHistory();

  const user = useSelector(state => state.sefaz.userProfile);
  const dadosApi = useSelector(state => state.formulario.dadosExibirDetalhar);

  const downloadFilePdf = () => {
    const windowContent = createHtmlComprovante(dadosApi, user);
    downloadFileHtmlToPdf(windowContent, 'Relatorio_FAS', ENUM_TIPO_LAYOUT_RELATORIO_DOWNLOAD.PAISAGEM, () =>
      history.push(detalharRequerimentoContribuinte)
    );
  };

  React.useEffect(() => {
    downloadFilePdf();
  });

  return (
    <div style={{ height: '40vh', textAlign: 'center', marginTop: '40vh' }}>
      <h2>Comprovante do Requerimento {dadosApi?.localizador}</h2>
      <a onClick={() => downloadFilePdf()}>Caso o download não inicie, clique aqui.</a>
    </div>
  );
}
